import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../config/api';

const ThemeContext = createContext({ theme: 'dark', toggleTheme: () => {}, setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    return localStorage.getItem('hopseat_theme') || 'dark';
  });
  const [bannerColor, setBannerColorState] = useState(() => {
    return localStorage.getItem('hopseat_banner_color') || 'ocean';
  });

  // Apply theme class to document root
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.classList.remove('dark-theme', 'light-theme');
    document.documentElement.classList.add(`${theme}-theme`);
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('hopseat_theme', theme);
  }, [theme]);

  const setTheme = async (newTheme) => {
    setThemeState(newTheme);
    localStorage.setItem('hopseat_theme', newTheme);
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      try {
        await axios.put(`${BACKEND_URL}/api/social/settings/theme`, { theme: newTheme }, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (e) { /* silent */ }
    }
  };

  const setBannerColor = (color) => {
    setBannerColorState(color);
    localStorage.setItem('hopseat_banner_color', color);
  };

  const toggleTheme = () => setTheme(theme === 'dark' ? 'light' : 'dark');

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, bannerColor, setBannerColor }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
export default ThemeContext;
